import React, { useState, ReactNode } from "react";
import Select from "react-select";
import {
  CURRENCY_SYMBOL,
  LEAD_LIST_FILTER
} from "@src/config/constant";
import * as HELPER from "@src/config/helper";
import DashboardFilterPopup from "@common/DashboardFilterPopup";
import { useNavigate } from 'react-router-dom';
import DetailRow from "@common/DetailRow";
import secureStorage from "@src/config/encrypt";
import { COMMISSION_DASHBOARD_KEY, DASHBOAED_TILES, ROLE } from "@src/config/id/constant";
import { useLanguage } from "@src/context/LanguageContext";



type CustomDateRange = {
  taskSummaryFilters: { from_date: string; to_date: string };
  pendingPaymentFilters: { from_date: string; to_date: string };
  raised_soa?: any;
};

interface props{
  title: string,
  data?: any,
  handleRedirection?:any,
  api:(params:any) => void
}

const PaidEarning = ({title,data, handleRedirection,api}:props) => {
  const [selectedOption, setSelectedOption] = useState({
    
    taskSummaryFilters: {
      label: LEAD_LIST_FILTER.taskSummaryFilters[1].label,
      value: LEAD_LIST_FILTER.taskSummaryFilters[1].value,
    },
    pendingPaymentFilters: {
      label: LEAD_LIST_FILTER.pendingPaymentFilters[0].label,
      value: LEAD_LIST_FILTER.pendingPaymentFilters[0].value,
    },
    raised_soa: null,
  });

  const navigate = useNavigate();
  const {translations} = useLanguage();
  

  const [filterList, setFilterList] = useState<any>({});
  const [filterType, setFilterType] = useState("");
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  let user_data = secureStorage.getItem("authAgentUserInfo");
  const roleId = user_data?.user_data?.role_id;
  const [customDateRange, setCustomDateRange] = useState<CustomDateRange>({
    taskSummaryFilters: { from_date: "", to_date: "" },
    pendingPaymentFilters: { from_date: "", to_date: "" },
  });

  const handleFilterPopup = (filters: any, key: string) => {
    setFilterList(filters);
    setFilterType(key);
    setShowFilterPopup(true);
  };
  const getFilterOption = (
    type: keyof typeof LEAD_LIST_FILTER,
    value: string | number
  ) => {
    const filterOptions = LEAD_LIST_FILTER[type];
    return (
      filterOptions?.find(
        (option) => option.value.toString() === value.toString()
      ) || null
    );
  };

  const applyFilter = (filter: any) => {
    const selectedFilterValue = filter[title];
    const updatedOption = getFilterOption(
      filterType as keyof typeof LEAD_LIST_FILTER,
      selectedFilterValue
    );
    if (updatedOption) {
      setSelectedOption((prev) => ({
        ...prev,
        [filterType]: {
          label: updatedOption.label,
          value: updatedOption.value,
        },
      }));
    }

    const filterDates =
      selectedFilterValue === "cdr"
        ? {
            from_date: filter.from_date || null,
            to_date: filter.to_date || null,
          }
        : HELPER.dateReturn(selectedFilterValue) || {
            from_date: null,
            to_date: null,
          };

    if (selectedFilterValue === "cdr") {
      setCustomDateRange((prevState) => ({
        ...prevState,
        [filterType]: {
          from_date: filter.from_date || "",
          to_date: filter.to_date || "",
        },
      }));
    }

    let finalFilter = {
      ...filter,
      ...filterDates,
    };

    const { [filterType]: _, ...rest } = finalFilter;
    finalFilter = rest;

    Object.keys(finalFilter).forEach((key) => {
      if (finalFilter[key] === null || finalFilter[key] === "") {
        delete finalFilter[key];
      }
    });

    api(finalFilter);
    
    
  };

  

  const handleFilterPopupClose = () => {
    setShowFilterPopup(false);
  };

  const handleRowClick = (type: string,status?:any) => {
    if(type === 'potential_payment'){
      handleRedirection(type);
    }
    else if (title === DASHBOAED_TILES.AGENT_COMMISSION) {
      // handle zero case here
      let query = '';

      if (status !== undefined && status !== null) {
        query = `?status=${status}`;
      }
      navigate(`/agentCommssion-list${query}`);
    }
    else{
      secureStorage.setItem("commission_type", type);
      navigate(`/commission-list`);  
    }
  };

  return (
    <React.Fragment>
      <DashboardFilterPopup
        show={showFilterPopup}
        handleClose={handleFilterPopupClose}
        filterList={filterList.length ? filterList : []}
        filterType={title}
        onSuccess={(response: any) => {
          applyFilter(response.applied_filter);
        }}
      />    
      <div className="summery-heading col-md-12">
        <h2>{translations?.DASHBOARD?.[title]}</h2>
        {
          title===DASHBOAED_TILES.PAID_EARNING && (
            <div className="task-right-panel">
              <fieldset className="single-select">
                <div
                  className="material"
                  onClick={() =>
                    handleFilterPopup(
                      LEAD_LIST_FILTER.taskSummaryFilters,
                      "taskSummaryFilters"
                    )
                  }
                >
                  <Select
                    value={selectedOption.taskSummaryFilters}
                    options={LEAD_LIST_FILTER.taskSummaryFilters}
                    placeholder="Till Today (All)"
                    className="react-select-opt custom-black-text"
                    classNamePrefix="react-select-opt"
                    isDisabled={true}
                  />
                </div>
              </fieldset>
            </div>
          )
        }
      </div>

      <div className="details col-md-12">
        {
          title===DASHBOAED_TILES.POTENTIAL_EARNING && 
          <DetailRow label={data?.potential_payment?.label} value={data?.potential_payment?.count} heading={data?.potential_payment?.amountTitle + ' ' + HELPER.addCurrencyFormatting(data?.potential_payment?.pending_amount)}  onClick={() => handleRowClick(data?.potential_payment?.type)}/>
        }
        {
          title === DASHBOAED_TILES.AGENT_COMMISSION
            ?
            <>
              {data?.agent_point_change?.map((val: any) => {
                const isApproved = (val.type === "approved"|| val.type === "pending");
                const translatedLabel = translations?.AGENT_COMMISSION?.STATUS_NAME?.[val.label] || val.label;

                let statusImg = "";
                if (val.type === "approved") statusImg = "/images/approve.png";
                else if (val.type === "pending") statusImg = "/images/approve.png";
                else if (val.type === "rejected") statusImg = "/images/reject.png";
                
                return (
                  <DetailRow
                    key={val.type}
                    label={
                      <div className="status-txt">
                        {/* {val.label} */}
                        <span className="status-count">{val.count}</span>
                       <span className="status-typ-txt"> {translatedLabel}</span>
                        
                      </div>
                      
                    }
                    //value={val.count}
                    value={
                      <div className="profile-img-container">
                      <img
                        src={statusImg}
                        alt="Profile"
                        className="profile-img rounded-circle"
                      />
                      </div>
                    }
                    onClick={() => handleRowClick(title, val.filter_params.status_id) }
                    //heading="test"
                    />
                )
              })
              }

            </>
            :
            <>
            {
              title===DASHBOAED_TILES.POTENTIAL_EARNING  && (
                <>
                <DetailRow label={translations?.COMMISSION?.COMMISSION} value={HELPER.addCurrencyFormatting(data?.[COMMISSION_DASHBOARD_KEY.POTENTIAL_PAYMENT]?.commission_earned)} onClick={() => handleRowClick(title)} />
                <DetailRow label={translations?.COMMISSION?.POINTS} value={HELPER.addCurrencyFormatting(data?.[COMMISSION_DASHBOARD_KEY.POTENTIAL_PAYMENT]?.points_earned).replace(CURRENCY_SYMBOL, '')} onClick={() => handleRowClick(title)} />
                </>
              )
            }
            {
              title===DASHBOAED_TILES.PAID_EARNING && (
                 <>
                <DetailRow label={translations?.COMMISSION?.EARNED_COMMISSION} value={HELPER.addCurrencyFormatting(data?.[COMMISSION_DASHBOARD_KEY.EARNING_SUMMARY]?.comission_earned)} onClick={() => handleRowClick(title)} />
                <DetailRow label={translations?.COMMISSION?.EARNED_POINTS} value={HELPER.addCurrencyFormatting(data?.[COMMISSION_DASHBOARD_KEY.EARNING_SUMMARY]?.points_earned)?.replace(CURRENCY_SYMBOL, '')} onClick={() => handleRowClick(title)} />
                </>
              )
            }
            </>
        }

      </div>
      {
          title===DASHBOAED_TILES.POTENTIAL_EARNING && (

       <div className="info-txt-bottom p-md-t d-flex w-100 col-md-12"><i className="ic-info-icon1 m-sm-r"></i>
       <span>{translations?.DASHBOARD?.PARAGRAPH}
       </span>
       </div>
          )}
    </React.Fragment>
  );
};


export default PaidEarning;
